import { render, staticRenderFns } from "./CreateOrganisationModal.vue?vue&type=template&id=9f53a156&"
import script from "./CreateOrganisationModal.vue?vue&type=script&lang=js&"
export * from "./CreateOrganisationModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganisationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports